/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/snippets/quantity-input.css":
/*!*****************************************!*\
  !*** ./src/snippets/quantity-input.css ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("{__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://ardene-theme/./src/snippets/quantity-input.css?\n}");

/***/ }),

/***/ "./src/snippets/snippet.quantity-input.js":
/*!************************************************!*\
  !*** ./src/snippets/snippet.quantity-input.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   QuantityInputComponent: () => (/* binding */ QuantityInputComponent)\n/* harmony export */ });\n/* harmony import */ var _quantity_input_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./quantity-input.css */ \"./src/snippets/quantity-input.css\");\n\n\nclass QuantityInputComponent extends HTMLElement {\n  constructor() {\n    super();\n  }\n\n  connectedCallback() {\n    // Query for child elements in connectedCallback to ensure they're available\n    // per custom elements spec: children may not be available in constructor\n    this.input = this.querySelector('input');\n    this.incrementButton = this.querySelector('[data-quantity-increment]');\n    this.decrementButton = this.querySelector('[data-quantity-decrement]');\n    this.min = parseInt(this.input?.min) || 1;\n    this.max = parseInt(this.input?.max) || 999;\n\n    if (this.incrementButton && this.decrementButton && this.input) {\n      this.incrementButton.addEventListener('click', this.increment.bind(this));\n      this.decrementButton.addEventListener('click', this.decrement.bind(this));\n      this.input.addEventListener('input', this.handleInput.bind(this));\n      this.updateButtonStates();\n    }\n  }\n\n  disconnectedCallback() {\n    if (this.incrementButton) {\n      this.incrementButton.removeEventListener('click', this.increment.bind(this));\n    }\n    if (this.decrementButton) {\n      this.decrementButton.removeEventListener('click', this.decrement.bind(this));\n    }\n    if (this.input) {\n      this.input.removeEventListener('input', this.handleInput.bind(this));\n    }\n  }\n\n  handleInput() {\n    this.updateButtonStates();\n  }\n\n  updateButtonStates() {\n    if (!this.input || !this.decrementButton || !this.incrementButton) return;\n    const quantity = parseInt(this.input.value) || this.min;\n    this.decrementButton.disabled = quantity <= this.min;\n    this.incrementButton.disabled = quantity >= this.max;\n  }\n\n  increment() {\n    if (!this.input || !this.incrementButton) return;\n    const quantity = parseInt(this.input.value);\n    if (quantity < this.max) {\n      this.input.value = quantity + 1;\n      this.input.dispatchEvent(new Event('change', { bubbles: true }));\n      this.updateButtonStates();\n      this.incrementButton.focus();\n    }\n  }\n\n  decrement() {\n    if (!this.input || !this.decrementButton) return;\n    const quantity = parseInt(this.input.value);\n    if (quantity > this.min) {\n      this.input.value = quantity - 1;\n      this.input.dispatchEvent(new Event('change', { bubbles: true }));\n      this.updateButtonStates();\n      this.decrementButton.focus();\n    }\n  }\n}\nif (!customElements.get('quantity-input')) {\n  customElements.define('quantity-input', QuantityInputComponent);\n}\n\n\n//# sourceURL=webpack://ardene-theme/./src/snippets/snippet.quantity-input.js?\n}");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/snippets/snippet.quantity-input.js");
/******/ 	
/******/ })()
;